import { testIDFactory } from '@onepercentio/one-ui/utils/e2e'

export const OPENED_VIEW_TEST_IDS = testIDFactory('opened-view')(['MY_COL'])
